var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7456",
    "data-name": "Group 7456",
    transform: "translate(-9275.775 -624)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(9275.775 624)",
    fill: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "queue-svgrepo-com",
    transform: "translate(9289.219 637.467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8027",
    "data-name": "Path 8027",
    d: "M57.939,50a4.925,4.925,0,0,1-3.3,1.327,8.6,8.6,0,0,1-1.144,3.8h6.407a1.377,1.377,0,0,0,1.373-1.373V53.2C61.235,51.693,59.587,50.778,57.939,50Z",
    transform: "translate(-38.168 -40.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8028",
    "data-name": "Path 8028",
    d: "M33.867,65.092a6.858,6.858,0,0,1-4.851,2.014A6.785,6.785,0,0,1,24.119,65C22.014,66.007,20,67.288,20,69.165v.87a1.787,1.787,0,0,0,1.785,1.785H36.11a1.787,1.787,0,0,0,1.785-1.785v-.824C37.895,67.288,35.973,66.053,33.867,65.092Z",
    transform: "translate(-20 -48.753)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1171",
    "data-name": "Ellipse 1171",
    cx: 4.897,
    cy: 5.4,
    rx: 4.897,
    ry: 5.4,
    transform: "translate(4.073 4.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8029",
    "data-name": "Path 8029",
    d: "M51.524,29.5A3.692,3.692,0,0,0,48,32.475,8.347,8.347,0,0,1,51.433,37.6h.092a3.894,3.894,0,0,0,3.661-4.073A3.821,3.821,0,0,0,51.524,29.5Z",
    transform: "translate(-35.185 -29.5)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPeople);
export default __webpack_public_path__ + "static/media/icon-people.71ae6f4dc192be92381d0f57036ffe0b.svg";
export { ForwardRef as ReactComponent };